import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=601cd63f&scoped=true&"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailModal.vue?vue&type=style&index=0&id=601cd63f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601cd63f",
  null
  
)

export default component.exports